import React from 'react';

import { SVGPropsType } from 'src/types';

function NoRecord(props: SVGPropsType) {
    const { fill, stroke, onClick, style, className } = props;

    return (
        <svg
            width="60"
            height="60"
            viewBox="0 0 60 60"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            onClick={onClick}
            style={style}
            className={className}
        >
            <path
                d="M55 30H40L35 37.5H25L20 30H5"
                stroke={stroke}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.5 12.75L5 30V45C5 47.75 7.25 50 10 50H50C52.75 50 55 47.75 55 45V30L46.25 12.75C45.5 11 43.75 10 41.75 10H18C16.25 10 14.5 11 13.5 12.75Z"
                stroke={stroke}
                strokeWidth="3"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M35 37.5H25L20 30H5V45C5 47.75 7.25 50 10 50H50C52.75 50 55 47.75 55 45V30H40L35 37.5Z"
                fill={fill}
            />
        </svg>
    );
}

export default NoRecord;
